import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
  createSelector
} from '@reduxjs/toolkit'


import reasonService from '../services/reasonService'


export const fetchAllReasons = createAsyncThunk('reason/fetchAllReasons', 
  async () => {
    const response = await reasonService.fetchAll()
    return response.data
})

export const fetchReason = createAsyncThunk('reason/fetchReason', 
  async (id) => {
    const response = await reasonService.fetch(id)
    return response.data
})
export const createReason = createAsyncThunk('reason/createReason', 
  async (reason) => {
    const response = await reasonService.create(reason)
    return response.data
})
export const updateReason = createAsyncThunk('reason/updateReason', 
  async (reason) => {
    const response = await reasonService.update(reason)
    return response.data
})
export const deleteReason = createAsyncThunk('reason/deleteReason', 
  async (id) => {
    const response = await reasonService.delete(id)
    return response.data
})


const addVCols=(x)=>{
  x.reason1 = x.reason.toLowerCase()
}


const reasonAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
  sortComparer: (a, b) => a.reason.toLowerCase().localeCompare(b.reason.toLowerCase())
})

const initialState = reasonAdapter.getInitialState();

const reasonSlice = createSlice({
  name: 'reason',
  initialState: initialState,
  reducers: {
    clearReasons(state, action) {
      state.error=null
      state.status='idle'
      reasonAdapter.removeAll(state)
    },
    reasonsSyncLoaded: {
      reducer(state, action) {
        reasonAdapter.setAll(state, action.payload)
      },
      prepare(reasonList) {
        if (reasonList && reasonList.length>0)
        {
          reasonList.forEach( addVCols);
        }
        return {payload:reasonList}
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAllReasons.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
      })
      .addCase(fetchAllReasons.fulfilled, (state, action) => {
        
        
        state.status = 'succeeded'
        if (action.payload) action.payload.forEach( addVCols);
        reasonAdapter.setAll(state, action.payload)
        //alert(312300)
        console.error(action.payload);
      })
      .addCase(fetchAllReasons.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(fetchReason.fulfilled, (state, action) => {
        if (action.payload) addVCols(action.payload, 0)
        reasonAdapter.upsertOne(state, action.payload)
      })
      .addCase(createReason.fulfilled, (state, action) => {
        if (action.payload) addVCols(action.payload, 0)
        reasonAdapter.addOne(state,action.payload)
      })
      .addCase(updateReason.fulfilled, (state, action) => {
        if (action.payload) addVCols(action.payload, 0)
        reasonAdapter.upsertOne(state , action.payload)
      })
      .addCase(deleteReason.fulfilled, (state, action) => {
        reasonAdapter.removeOne(state,action.payload)
      })
  }

}
)

export const { reasonsSyncLoaded,clearReasons } = reasonSlice.actions

export default reasonSlice.reducer;

export const {
  selectAll:  selectAllReasons,
  selectById: xselectReasonById,
  selectIds:  selectAllReasonIds,
} = reasonAdapter.getSelectors((state) => state.reason)


export const selectReasonById = (id)=>(state)=>xselectReasonById(state, id)

const filterPredicate =(r, f)=>{
  if (!Boolean(f)) return true;
  return r.reason.toLowerCase().includes(f);
} 

export const selectReasonIdsByFilter = 
createSelector(
  [	selectAllReasons, 	(state, filter)=>(filter?filter.toLowerCase():'')],
  (reasons, fff) =>reasons.filter( v=>filterPredicate(v, fff) ).map(x=>x.id)
)



